import { Navigate } from "react-router";
import type { AppRouteObject } from "./types";
import { lazyRoute } from "./lazyRoute";
import { withLaboratoryRootMetadata } from "./featureRouteMetadata";

export const laboratoryRoutes = withLaboratoryRootMetadata({
    path: "labs",
    handle: { help: null },
    children: [
        {
            index: true,
            lazy: lazyRoute(() => import("../containers/Labs/Labs/LabsPage")),
            handle: { help: { topicKey: "labs" } }
        },
        {
            path: "create",
            lazy: lazyRoute(() => import("../containers/Labs/Lab/LabPage"), { mode: "create" }),
            handle: { help: { topicKey: "lab" } }
        },
        {
            path: ":laboratoryId",
            handle: { help: null },
            children: [
                {
                    index: true,
                    element: <Navigate replace to="details" />,
                    handle: { help: null }
                },
                {
                    path: "details",
                    lazy: lazyRoute(() => import("../containers/Labs/Lab/LabPage"), { mode: "edit" }),
                    handle: { help: { topicKey: "lab" } }
                },
                {
                    path: "departments",
                    handle: { help: { topicKey: "lab-departments" } },
                    children: [
                        {
                            index: true,
                            lazy: lazyRoute(() => import("../containers/Labs/LabDepartments/LabDepartmentsPage")),
                            handle: { help: { topicKey: "lab-departments" } }
                        },
                        {
                            path: "create",
                            lazy: lazyRoute(() => import("../containers/Labs/LabDepartment/LabDepartmentPage"), { mode: "create" }),
                            handle: { help: { topicKey: "lab-department" } }
                        },
                        {
                            path: ":laboratoryDepartmentId",
                            handle: { help: null },
                            children: [
                                {
                                    index: true,
                                    element: (
                                        <Navigate replace to="details" />
                                    ),
                                    handle: { help: null }
                                },
                                {
                                    path: "details",
                                    lazy: lazyRoute(() => import("../containers/Labs/LabDepartment/LabDepartmentPage"), { mode: "edit" }),
                                    handle: { help: { topicKey: "lab-department" } }
                                },
                            ],
                        },
                    ],
                },
                {
                    path: "personnel",
                    handle: { help: null },
                    children: [
                        {
                            index: true,
                            lazy: lazyRoute(() => import("../containers/Labs/LabPersonnels/LabPersonnelsPage")),
                            handle: { help: { topicKey: "lab-personnels" } }
                        },
                        {
                            path: "create",
                            lazy: lazyRoute(() => import("../containers/Labs/LabPersonnel/LabPersonnelPage")),
                            handle: { help: { topicKey: "lab-personnel" } }
                        },
                        {
                            path: ":laboratoryPersonnelId",
                            handle: { help: null },
                            children: [
                                {
                                    index: true,
                                    element: (
                                        <Navigate replace to="details" />
                                    ),
                                    handle: { help: null }
                                },
                                {
                                    path: "details",
                                    lazy: lazyRoute(() => import("../containers/Labs/LabPersonnel/LabPersonnelPage")),
                                    handle: { help: { topicKey: "lab-personnel" } }
                                },
                            ],
                        },
                    ],
                },
                {
                    path: "institutions",
                    handle: { help: null },
                    children: [
                        {
                            index: true,
                            lazy: lazyRoute(() => import("../containers/Labs/LabInstitutions/LabInstitutionsPage")),
                            handle: { help: { topicKey: "lab-institutions" } }
                        },
                        {
                            path: "create",
                            lazy: lazyRoute(() => import("../containers/Labs/LabInstitution/LabInstitutionPage"), { mode: "create" }),
                            handle: { help: { topicKey: "lab-institution" } }
                        },
                        {
                            path: ":institutionLaboratoryId",
                            handle: { help: null },
                            children: [
                                {
                                    index: true,
                                    element: (
                                        <Navigate replace to="details" />
                                    ),
                                    handle: { help: null }
                                },
                                {
                                    path: "details",
                                    lazy: lazyRoute(() => import("../containers/Labs/LabInstitution/LabInstitutionPage"), { mode: "edit" }),
                                    handle: { help: { topicKey: "lab-institutions" } }
                                },
                            ],
                        },
                    ],
                },
                {
                    path: "finance",
                    lazy: lazyRoute(() => import("../containers/Labs/LabFinance/LabFinancePage")),
                    handle: { help: { topicKey: "lab-finance" } }
                },
                {
                    path: "contract",
                    lazy: lazyRoute(() => import("../containers/Labs/LabContract/LabContractPage")),
                    handle: { help: { topicKey: "lab-contract" } }
                },
            ],
        },
    ],
} satisfies AppRouteObject);

